enum SortingKeys {
  Popularity = 'popularity',
  Distance = 'distance',
  Joined = 'joined',
  Review = 'review'
}

export default SortingKeys
